<script lang="ts">
  import { Accordion, AccordionItem, Button, Card, Col } from "sveltestrap";
  import data from "../../../Data/SocialApp/SocialApp.json";
  import { ProfileIntro, SocialNetworks } from "../../../utils/Constant/Constant";
</script>
<Col xl="12" md="6" class="xl-50 box-col-6">
    <Card>
      <Accordion>
          <AccordionItem active header={ProfileIntro}>
              <div class="filter-cards-view">
                  {#each data.profileintrodata as profileItem}
                      <span class="f-w-600 mb-2 d-block">{profileItem.title}</span>
                      <p>{profileItem.detail}</p>
                  {/each}
                  <div class="social-network theme-form">
                      <span class="f-w-600">{SocialNetworks}</span>
                      {#each data.socialbtndata as socialItem}
                          <Button class="social-btn {socialItem.class} mb-2 text-center" href={socialItem.link} target="_blank">
                              <i class="{socialItem.icon} m-r-5"></i>{socialItem.name}
                          </Button>
                      {/each}
                  </div>
              </div>
          </AccordionItem>
      </Accordion>
    </Card>
</Col>